const de = {
  common: {
    nav: { services: "Leistungen", about: "Über uns", guides: "Guides", contact: "Kontakt" },
    cta: "Projekt starten",
    language: "Sprache",
    themeToLight: "Zum hellen Modus wechseln",
    themeToDark: "Zum dunklen Modus wechseln",
    menuOpen: "Menü öffnen",
    menuClose: "Menü schließen",
    optional: "optional",
    reply: "Wir antworten innerhalb von 7 Stunden.",
    scroll: "Scrollen",
  },
  footer: {
    tagline: "KI-Automatisierung, Websites und Apps für Teams, die Routinearbeit Systemen überlassen wollen.",
    company: "Unternehmen",
    policies: "Richtlinien",
    elsewhere: "Social Media",
    location: "Bikaner, Rajasthan, Indien · Weltweit tätig",
    legal: {
      terms: "AGB",
      privacy: "Datenschutz",
      refund: "Erstattungsrichtlinie",
      return: "Rückgaberichtlinie",
      cancellation: "Stornierungsrichtlinie",
      shipping: "Versandrichtlinie",
    },
  },
  cookie: {
    title: "Cookies, nur mit Ihrer Zustimmung",
    body: "Wir verwenden notwendige Cookies für den Betrieb der Website. Mit Ihrer Zustimmung nutzen wir zusätzlich Analyse-Cookies, um sie zu verbessern.",
    accept: "Alle akzeptieren",
    reject: "Nur notwendige",
    policy: "Datenschutz",
  },
  cta: {
    title: "Ein Prozess, der von selbst laufen sollte?",
    body: "Sagen Sie uns, was Sie brauchen. Wir antworten innerhalb von 7 Stunden.",
    primary: "Gespräch starten",
    secondary: "Leistungen ansehen",
  },
  home: {
    hero: {
      eyebrow: "Studio für KI-Automatisierung und Software",
      titleA: "Wir bauen Systeme,",
      titleB: "die für Sie arbeiten.",
      lede: "KI-Agenten, Automatisierungen, Websites und Apps — konzipiert, gebaut und ausgeliefert aus einer Hand.",
      primary: "Projekt starten",
      secondary: "Unsere Arbeiten",
      tags: ["KI-Agenten", "Automatisierung", "Web-Apps", "Mobile Apps", "Datenpipelines", "KI-Video"],
    },
    marquee: ["KI-Agenten", "RAG-Systeme", "Automatisierung", "Websites", "Web-Apps", "Mobile Apps", "Web-Scraping", "KI-Video", "Python", "n8n"],
    stats: [
      { value: 4, suffix: "+", label: "Jahre Erfahrung mit KI-Systemen" },
      { value: 100, suffix: "+", label: "automatisierte Workflows" },
      { value: 7, suffix: " Std.", label: "maximale Antwortzeit" },
    ],
    services: { label: "Was wir tun", title: "Vier Wege, wie wir helfen.", more: "Alle Leistungen" },
    work: {
      label: "Ausgewählte Arbeiten",
      title: "Live-Projekte, die wir umgesetzt haben.",
      intro: "Öffnen Sie eine Karte, um das Original zu sehen.",
      nextLabel: "Ihr Projekt",
      nextTitle: "Vielleicht das nächste.",
      nextBody: "Websites, Apps und Automatisierung aus einer Hand.",
      nextCta: "Erzählen Sie uns davon",
      visit: "Website in neuem Tab öffnen",
    },
    process: {
      label: "So arbeiten wir",
      title: "Von der Idee zum Launch in vier Schritten.",
      steps: [
        { title: "Verstehen", desc: "Ein kostenloses Gespräch über Ihr Ziel." },
        { title: "Planen", desc: "Ein klarer schriftlicher Plan mit Zeitrahmen." },
        { title: "Bauen", desc: "Funktionierende Demos an jedem Meilenstein." },
        { title: "Starten", desc: "Go-live, danach Support." },
      ],
    },
    testimonials: { label: "Kundenstimmen", title: "Was unsere Kunden sagen." },
  },
  services: {
    eyebrow: "Leistungen",
    title: "Fokussierte Leistungen, ausgerichtet auf Ihr Ziel.",
    lede: "Jedes Projekt beginnt mit einem kostenlosen Erstgespräch.",
    timeline: "Übliche Dauer",
    included: "Enthalten",
    tools: "Unsere Tools",
    showTools: "Tools anzeigen",
    hideTools: "Tools ausblenden",
    options: "Einstiegsoptionen",
    choose: "Auswählen",
    discuss: "Projekt besprechen",
    extrasTitle: "Außerdem",
    extras: ["KI-Beratung", "Architektur-Design", "API-Integration", "Cloud & DevOps", "Wartung & Support", "Dedizierte Entwickler"],
    items: {
      "ai-automation": {
        title: "KI-Automatisierung",
        tagline: "Agenten und Assistenten, die Ihrem Team Routinearbeit abnehmen.",
        timeline: "2–12 Wochen",
        includes: ["Prozessanalyse", "KI-Chatbots & Agenten", "Wissensassistenten (RAG)", "CRM- & Tool-Integration", "30 Tage Support"],
        plans: [
          { name: "Einstiegs-Automatisierung", note: "Ein Workflow · 2–3 Wochen" },
          { name: "Business-Automatisierung", note: "Mehrere Workflows · 4–6 Wochen" },
          { name: "KI-Systeme für Unternehmen", note: "Volle Integration · 8–12 Wochen" },
        ],
      },
      "web-development": {
        title: "Websites & Web-Apps",
        tagline: "Schnelle, moderne Websites und Apps, einfach zu betreiben.",
        timeline: "1–10 Wochen",
        includes: ["UI/UX-Design", "Responsive Umsetzung", "Admin-Bereich", "SEO & Performance", "60 Tage Support"],
        plans: [
          { name: "Statische Firmenwebsite", note: "5–7 Seiten · 1–2 Wochen" },
          { name: "Dynamische Website mit Admin", note: "Admin-Bereich · 3–4 Wochen" },
          { name: "Individuelle Web-App", note: "Eigene Funktionen · 6–10 Wochen" },
        ],
      },
      "python-automation": {
        title: "Python & Daten",
        tagline: "Skripte, Scraper und Pipelines, die selbstständig laufen.",
        timeline: "3 Tage–4 Wochen",
        includes: ["Individuelle Skripte", "Web-Scraping", "Datenverarbeitung", "Geplante Jobs", "Logging & Doku"],
        plans: [
          { name: "Einfaches Automatisierungsskript", note: "Eine Aufgabe · 3–5 Tage" },
          { name: "Web-Scraping-Lösung", note: "Mehrere Seiten · 1–2 Wochen" },
          { name: "Komplexe Datenpipeline", note: "Viele Quellen · 2–4 Wochen" },
        ],
      },
      "ai-video": {
        title: "KI-Video & Avatare",
        tagline: "Videoinhalte in großer Menge, ganz ohne Cutter.",
        timeline: "2–10 Wochen",
        includes: ["Eigene Avatare", "Sprachsynthese", "Vom Skript zum Video", "Markengerechtes Design", "Team-Schulung"],
        plans: [
          { name: "KI-Video-Basis", note: "Ein Avatar · 2–3 Wochen" },
          { name: "Professionelles Avatar-System", note: "Stimmklon · 4–5 Wochen" },
          { name: "Video-Plattform für Unternehmen", note: "API & White-Label · 6–10 Wochen" },
        ],
      },
    },
  },
  about: {
    eyebrow: "Über uns",
    title: "Ein kleines Team für praktische KI.",
    lede: "Wir ersetzen Routinearbeit durch zuverlässige Systeme — vom einzelnen Skript bis zur ganzen Plattform.",
    storyLabel: "Unsere Geschichte",
    story: "Wir haben Optivra Tech gegründet, um moderne KI in den Arbeitsalltag zu bringen. Erst verstehen wir, wie Sie arbeiten, dann bauen wir, was passt.",
    valuesLabel: "Was uns leitet",
    values: [
      { title: "Mission", desc: "Messbares Wachstum durch praktische KI und Automatisierung." },
      { title: "Vision", desc: "Der Technologiepartner, dem wachsende Unternehmen vertrauen." },
      { title: "Anspruch", desc: "Qualität, klare Kommunikation, echte Ergebnisse." },
    ],
    skillsLabel: "Expertise",
    skillsTitle: "Worin wir stark sind.",
    skillsHint: "Karte berühren oder mit der Maus darüberfahren, um die Tools zu sehen.",
    skills: [
      { title: "KI & ML", tools: "OpenAI · LangChain · RAG · PyTorch" },
      { title: "Backend", tools: "Python · FastAPI · Node.js · Django" },
      { title: "Frontend", tools: "React · Next.js · TypeScript · Tailwind" },
      { title: "Daten", tools: "MongoDB · PostgreSQL · Redis · Pinecone" },
      { title: "Cloud", tools: "AWS · Google Cloud · Azure · Docker" },
      { title: "Automatisierung", tools: "n8n · Selenium · Scrapy · Airflow" },
    ],
    teamLabel: "Das Team",
    team: ["KI- & Automatisierungsingenieure", "Full-Stack-Entwickler", "Lösungsarchitekten", "DevOps-Ingenieure"],
    whyLabel: "Warum wir",
    why: [
      { title: "Schnell", desc: "Kurze Zyklen, echte Demos." },
      { title: "Aktuell", desc: "Bewährte, moderne Tools." },
      { title: "Sauber", desc: "Dokumentierter, wartbarer Code." },
    ],
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Lassen Sie uns sprechen.",
    lede: "Erzählen Sie uns von Ihrem Projekt. Wir antworten innerhalb von 7 Stunden.",
    name: "Vollständiger Name",
    email: "E-Mail",
    phone: "Telefon",
    subject: "Betreff",
    subjectPh: "z. B. Rechnungsverarbeitung automatisieren",
    message: "Nachricht",
    messagePh: "Was brauchen Sie, und welche Tools sind beteiligt?",
    send: "Nachricht senden",
    sending: "Wird gesendet…",
    privacy: "Wir geben Ihre Daten niemals weiter.",
    okTitle: "Nachricht gesendet",
    okBody: "Danke! Wir antworten innerhalb von 7 Stunden.",
    errTitle: "Etwas ist schiefgelaufen",
    errBody: "Die Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.",
    emailLabel: "E-Mail",
    phoneLabel: "Telefon",
    hoursLabel: "Zeiten",
    hours: "Mo–Sa, 9:00–19:00 IST",
  },
  checkout: {
    eyebrow: "Projekt starten",
    title: "Sagen Sie uns, was Sie brauchen.",
    lede: "Wählen Sie die passendste Option. Den Umfang stimmen wir mit Ihnen ab.",
    details: "Ihre Angaben",
    project: "Projekt",
    name: "Vollständiger Name",
    company: "Firma",
    email: "E-Mail",
    phone: "Telefon",
    service: "Leistung",
    selectService: "Leistung wählen",
    option: "Option",
    selectOption: "Option wählen",
    notes: "Projektnotizen",
    notesPh: "Was soll es tun? Mit welchen Tools soll es verbunden werden?",
    agree: "Ich akzeptiere die",
    and: "und die",
    submit: "Projektanfrage senden",
    submitting: "Wird gesendet…",
    summary: "Übersicht",
    summaryService: "Leistung",
    summaryOption: "Option",
    next: "Wir antworten innerhalb von 7 Stunden, um Umfang und nächste Schritte zu klären.",
    empty: "Wählen Sie eine Leistung und eine Option.",
    perks: ["Sichere Abwicklung", "7 Tage Erstattungsfrist", "Antwort innerhalb von 7 Stunden"],
    refundLink: "Erstattungsrichtlinie",
    termsTitle: "Zustimmung erforderlich",
    termsBody: "Bitte akzeptieren Sie die Bedingungen, um fortzufahren.",
    okTitle: "Anfrage erhalten",
    okBody: "Danke! Wir melden uns innerhalb von 7 Stunden.",
    errTitle: "Etwas ist schiefgelaufen",
    errBody: "Die Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
  },
  guide: {
    eyebrow: "Guides",
    title: "Praxis-Guides aus echten Kundenprojekten.",
    lede: "Schritt-für-Schritt-Anleitungen zu KI, Automatisierung und Karriere.",
    badges: ["Sofortiger PDF-Download", "Kopie per E-Mail", "Sichere Zahlung über PhonePe"],
    listLabel: "Verfügbare Guides",
    listTitle: "Guide auswählen.",
    mins: "Min.",
    levels: { "All Levels": "Alle Stufen", Beginner: "Einsteiger", Intermediate: "Fortgeschritten", Advanced: "Experte" },
    choose: "Auswählen",
    selected: "Ausgewählt",
    items: {
      g0: "Ein 30–45-Tage-Plan zum Traumjob: Lebenslauf, Interviews, Kontaktaufnahme.",
      g1: "Diffusionsmodelle, eigene Nodes und schnelles Prototyping in ComfyUI.",
      g2: "Autonome Systeme bauen, die manuelle Arbeit ersetzen.",
      g3: "Vektordatenbanken, Chunking und der Einsatz von Wissensagenten.",
      g4: "n8n hosten und App-übergreifende Abläufe mit Webhooks bauen.",
    },
    buyLabel: "Kasse",
    buyTitle: "Holen Sie sich Ihr Exemplar.",
    buySub: "Für Ihre Rechnung und den Download-Link per E-Mail.",
    name: "Vollständiger Name",
    phone: "Telefon",
    email: "E-Mail",
    country: "Land",
    countries: { India: "Indien", "United States": "Vereinigte Staaten", "United Kingdom": "Vereinigtes Königreich", Canada: "Kanada", Australia: "Australien", Germany: "Deutschland", Other: "Anderes" },
    gst: "GST-Nummer",
    company: "Firmenname",
    agree: "Ich akzeptiere die",
    and: "und die",
    terms: "AGB",
    refund: "Erstattungsrichtlinie",
    pay: "{amount} sicher bezahlen",
    redirecting: "Weiterleitung zur Zahlung…",
    buying: "Ihr Kauf",
    format: "PDF-Guide · digitaler Download",
    price: "Preis",
    gstLine: "GST ({percent} %)",
    total: "Gesamt",
    loadingPrice: "Preis wird geladen…",
    methods: "Zahlen Sie per UPI, Karte, Online-Banking oder Wallet.",
    secure: "Zahlungen werden sicher über PhonePe abgewickelt.",
    faqLabel: "FAQ",
    faqTitle: "Häufige Fragen.",
    faqs: [
      { q: "In welchem Format kommen die Guides?", a: "Als PDF mit Diagrammen, Code-Beispielen und Schritt-für-Schritt-Anleitungen." },
      { q: "Wie schnell erhalte ich ihn?", a: "Sofort. Sie gelangen zu einer Download-Seite und erhalten eine Kopie per E-Mail." },
      { q: "Kann ich eine Erstattung erhalten?", a: "Da Guides sofortige Downloads sind, sind Erstattungen eingeschränkt. Siehe Erstattungsrichtlinie." },
      { q: "Wer schreibt die Guides?", a: "Unsere Ingenieure, basierend auf Systemen, die sie für Kunden bauen." },
    ],
    errors: {
      "Full name is required": "Bitte vollständigen Namen angeben",
      "Email is required": "Bitte E-Mail angeben",
      "Please enter a valid email": "Bitte gültige E-Mail eingeben",
      "Phone number is required": "Bitte Telefonnummer angeben",
      "Please enter a valid phone number": "Bitte gültige Telefonnummer eingeben",
      "You must accept the terms": "Bitte akzeptieren Sie die Bedingungen",
      "Something went wrong. Please try again.": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    },
  },
  success: {
    verifying: "Zahlung wird bestätigt…",
    pending: "Zahlung wird noch verarbeitet",
    checking: "Automatische erneute Prüfung ({n}/10)",
    checkAgain: "Erneut prüfen",
    paid: "Zahlung erhalten. Vielen Dank!",
    downloads: "Ihre Downloads",
    dlGuide: "Guide herunterladen (PDF)",
    dlInvoice: "Rechnung herunterladen (PDF)",
    linksNote: "Die Links sind 24 Stunden gültig. Eine Kopie wurde auch per E-Mail gesendet.",
    expired: "Dieser Download-Link ist abgelaufen",
    failed: "Das hat leider nicht geklappt",
    support: "Support kontaktieren",
    home: "Zur Startseite",
    errors: {
      "No order ID found. Please check your payment email for order details.": "Keine Bestellung gefunden. Details finden Sie in Ihrer Zahlungs-E-Mail.",
      "Payment failed. Please try again.": "Zahlung fehlgeschlagen. Bitte erneut versuchen.",
      "Unable to verify payment status.": "Zahlungsstatus konnte nicht geprüft werden.",
      "Download links have expired after 24 hours.": "Die Download-Links sind nach 24 Stunden abgelaufen.",
      "Unable to fetch download links.": "Download-Links konnten nicht geladen werden.",
      "Download failed. Please try again or contact support.": "Download fehlgeschlagen. Bitte erneut versuchen oder Support kontaktieren.",
      "Something went wrong.": "Etwas ist schiefgelaufen.",
    },
  },
  legal: { notice: "Diese Richtlinie wird auf Englisch veröffentlicht; die englische Fassung ist rechtsverbindlich." },
  work: {
    kke: { kind: "Kunden-Website", summary: "Mehrsprachiger Katalog für einen weltweit exportierenden Industriezulieferer.", highlights: ["Englisch, Französisch & Arabisch", "12 Produktlinien", "Angebote & WhatsApp"] },
    pokemac: { kind: "Eigenes Produkt · macOS-App", summary: "Eine verspielte Menüleisten-App, die auf Klapse, Deckel und USB reagiert.", highlights: ["Native macOS-App", "Läuft lokal"] },
    drillbuddy: { kind: "Eigenes Produkt · Android-App", summary: "Audiobasierte Reaktionsübungen für Ringen, MMA und Badminton.", highlights: ["Google Play", "Einstellbare Intensität"] },
    prayer: { kind: "Eigenes Produkt · Android-App", summary: "Ein ruhiger Gebetszähler mit Themes und täglichem Fortschritt.", highlights: ["8 Sprachen", "Google Play"] },
  },
};

export default de;
